export default "__VITE_ASSET__2e8f03c2__"